import React from 'react'
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from "@material-ui/pickers";
import jMoment from "moment-jalaali";
import JalaliUtils from "@date-io/jalaali";
import './index.module.scss';


jMoment.loadPersian({ dialect: "persian-modern", usePersianDigits: true });

const Index = ({ label, value, setValue , required })=> {


    return (
        <div className={'bg-white'}>
            <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa" >
                <KeyboardDatePicker
                    clearable
                    label={label}
                    okLabel="تایید"
                    cancelLabel="لغو"
                    clearLabel="پاک کردن"
                    // labelFunc={value ? date => date.format("jYYYY/jMM/jDD") : ""}
                    // labelFunc={value ? date =>  date?.format("jYYYY/jMM/jDD") : ""}
                    labelFunc={value ? date =>  ( 
                    (date && typeof date !== 'string')
                    ? date?.format("jYYYY/jMM/jDD") 
                    :typeof date === 'string' 
                       ? value?.split(' ')?.[0]
                       : null
                       ) : null}
    // 
    

                    value={ (value && typeof value !== 'string')
                    ? value?.format("jYYYY/jMM/jDD") 
                    :typeof value === 'string' 
                       ? value?.split(' ')?.[0]
                       :null}
                    style={{ width: '100%' }}
                    onChange={data => {
                        setValue(data)
                    }}
                    size="small"
                    // format="jYYYY/jMM/jDD"
                    minDateMessage={<p>آیکون را کلیک کنید</p>}
                    
                // minDate={moment().subtract(6, "months")}
                // maxDate={moment()}
                required ={required}
                />
            </MuiPickersUtilsProvider>
        </div>
    )
}


export default  Index